module.exports = __webpack_public_path__ + "static/img/theme_5.b5033fe6.png";